import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';
import { errorLogger } from '@utils/errorLogger.util.js';
import { sendToPrinter } from '../lib/api/fetchRequestPrint';

export const usePrinterSummationStore = create((set) => ({
  loading: false,
  error: null,
  result: null,

  sendToPrinter: async (chat_id, printer_id) => {
    set({ error: null, loading: true });

    try {
      const response = await sendToPrinter(chat_id, printer_id);

      if (!response.success) {
        set({ error: response.message });
        return;
      }

      set({
        error: null,
        result: response,
      });
    } catch (error) {
      errorLogger.error(error, { source: usePrinterSummationStore.name });
      set({ error: 'Error. Please reload the page.' });
    } finally {
      set({ loading: false });
    }
  },
}));

export const usePrinterSummationData = () => {
  return usePrinterSummationStore(
    useShallow((state) => ({
      error: state.error,
      result: state.result,
      sendToPrinter: state.sendToPrinter,
      isPrinterLoading: state.loading,
      printerError: state.error,
      printerResult: state.result,
    })),
  );
};
